// @ts-nocheck
import React from 'react';
import WorkflowPage from './WorkflowPageFactory';
import { DocumentGeneration } from '../workflow/CompanyApp';

export default function DocumentsPage() {
  return (
    <WorkflowPage stepId="documents">
      {({ data, documentsSubTab }) => <DocumentGeneration formData={data} subTab={documentsSubTab} />}
    </WorkflowPage>
  );
}
